import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarFilterButton,
  ruRU,
} from "@material-ui/data-grid";
import Grid from "@material-ui/core/Grid";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import {
  selectContractorAct,
  loadingContractorActs,
} from "../../redux/reducers/contractor-act-reducer";
import { contractorActColumns } from "./actColumns";
import { useDialog } from "../../hooks/useDialog";

import { getProfile } from "../../redux/reducers/user-profile-reducer.js";
import { Dialog } from "../../components/Dialog/Dialog";
import { makeStyles } from "@material-ui/styles";
import { contractorFields } from "./contractorFields";
import { DynamicFieldComponent } from "../../components/DynamicFieldComponent/DynamicFieldComponent";
import { useFormik } from "formik";
import {
  generateFormikInitialValues,
  generateFormikValidationSchema,
} from "../../utils/dynamicFields";
import { Button } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Loader from "../../components/Loader/Loader";
import {
  loadingContractorViolations,
  selectContractorViolations,
} from "../../redux/reducers/contractor-violation-reducer";
import { MasterOfActsAPI } from "../../api/api";
import {
  contractorDataPutCorrector,
  contractorFieldsSetDisable,
} from "../../utils/contractorDataPutCorrector";
import { Select } from "../../components/tools/SelectorOrText/Select";
import { cleanHashViolation, getActs, getInfoAct, getInfoViolation } from "../../redux/reducers/act-reducer";
import QrCodeViolation from "../../components/DynamicFieldComponent/uploads/qr_code/qrCodeViolation";




export const useStyles = makeStyles((theme) => ({
  contractorButton: {
    color: "#2e5485",
    border: "none",
    background: "#F5F5F5",
    borderRadius: "10px",
  },
  smallButtonLabel: {
    fontSize: "1.125rem",
    fontWeight: 400,
    lineHeight: "21px",
    letterSpacing: "0.00714em",
    textTransform: "none",
    display: "inline",
  },
  tableError: {
    borderColor: theme.palette.error.main,
  },
  header: {
    // paddingBottom: theme.spacing(1),
    color: "#2e5485",
  },
  selectOption: {
    backgroundColor: theme.palette.common.white,
    width: 175
  },
  selectOutlined: {
    padding: '8.5px 35px 8.5px 10px'
  },
}));

const ContractorButton = ({ children, onClick }) => {
  const classes = useStyles();

  return (
    <Button
      onClick={onClick}
      classes={{ outlined: classes.contractorButton }}
    >
      <Typography
        variant={"body1"}
        classes={{ body1: classes.smallButtonLabel }}
      >
        {children}
      </Typography>
    </Button>
  );
};

const CustomToolbar = ({ value, onChange }) => {
  return (
    <GridToolbarContainer>
      <Grid
        container
        direction={"row"}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Grid item>
          <GridToolbarFilterButton />
          <GridToolbarDensitySelector />
        </Grid>
        <Grid
          item
          xs
          container
          alignItems={"center"}
          justifyContent={"flex-end"}
        >
          <Grid item>
            <TextField
              variant="standard"
              value={value}
              onChange={onChange}
              placeholder="Поиск…"
              InputProps={{
                startAdornment: <SearchIcon fontSize="small" />,
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </GridToolbarContainer>
  );
};


const podrOrganizations = [
  {id: "ООО «БКЕ» ФРС" , name: "ООО «БКЕ» ФРС"},
  {id: "ООО «Мастернефтьcервис»" , name: "ООО «Мастернефтьcервис»"},
  {id: "ООО «ВэллСервис»" , name: "ООО «ВэллСервис»"},
]


const ContractorSaveButton = ({onClick}) => {
  const { user } = useSelector(getProfile);
  return( <>
  { !(user?.role === "project_editor" || user?.role === "employer" || user?.role === "employer_additional") &&
    <ContractorButton onClick={onClick}>Сохранить</ContractorButton>}
  </> 
  );   
}



export const ContractorAct = () => {


  const infoAct = useSelector(getInfoAct)
  const infoViolation = useSelector(getInfoViolation)



  const columns = useMemo(() => contractorActColumns, []);
  const classes = useStyles();

  const [podr, setPodr] = useState(infoAct !== null ? infoAct.content?.podrCompanystep1 ? infoAct.content.podrCompanystep1 : 'ООО «БКЕ» ФРС' : 'ООО «БКЕ» ФРС');
  const [pageSize, setPageSize] = React.useState(25);

  const handleContractors = (event) => {
    setPodr(event.target.value);
  }

  const { user } = useSelector(getProfile);
 
  const whichUser = () => {
    if (user?.is_staff || user?.role === "project_editor" || user?.role === "employer" || 
          user?.role === "employer_additional") return podr
      return user.organization
  }



  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(loadingContractorActs(whichUser()));
  }, [podr]);

 
  const { contractorActs, loading } = useSelector(selectContractorAct);

  const { loadingViolations, loadingFiles, violationData, ...initialData } =
    useSelector(selectContractorViolations);


  const handleFile = (rows) => {
    let rowWithFiles = []
    rows.map((el) => {
      let actFile = {papa: 1}
      let fakeEl = {...el, ...actFile}
      fakeEl.actFile = {actId: el.id, environmentStateId: 966}
      rowWithFiles.push(fakeEl)
    })

    return rowWithFiles
  }

  

  const [searchText, setSearchText] = useState("");
  const [currentRows, setCurrentRows] = useState(handleFile(contractorActs));
  const [qr, setQr] =  useState("")

  const escapeRegExp = (value) => {
    return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
  };

  const requestSearch = (searchValue) => {
    setSearchText(searchValue);
    const searchRegex = new RegExp(escapeRegExp(searchValue), "i");
    const filteredRows = contractorActs.filter((row) => {
      return Object.keys(row).some((field) => {
        return searchRegex.test(row[field].toString());
      });
    });
    setCurrentRows(filteredRows);
  };

  const { open, handleClose, handleOpen } = useDialog();
  const [selectedAct, setSelectedAct] = useState(undefined);


  useEffect(() => {  
    setCurrentRows(contractorActs);
  }, [contractorActs]);

  useMemo(() => {
    if (infoAct !== null && infoViolation !== null) {
      const buildViolationRow = {
        act_date: '',
        crew_number: infoAct.content.numBrigade,
        field: `${infoAct.content.field}/${infoAct.content.padstep1}/${infoAct.content.wellstep1}`,
        id: infoAct.id,
        organization: infoAct.content.podrCompanystep1,
        podrFIO: infoAct.content.podrFIO,
        sequenceNumber: null,
        status: infoViolation.removal_status,
        violation_id: infoViolation.id,
        violation_name: infoViolation.name,
      }
      setSelectedAct(buildViolationRow);
      dispatch(loadingContractorViolations(buildViolationRow.violation_id, buildViolationRow.organization));
      handleOpen();
    }
    

  },[infoAct])

  const clearViolationInfo = () => {
    dispatch(cleanHashViolation())
  }

  const onTableRowClick = ({ row }) => {
    setSelectedAct(row);
    dispatch(loadingContractorViolations(row.violation_id, row.organization));
    handleOpen();
  };

  let contractorFieldsWithDisable = contractorFieldsSetDisable(
    initialData,
    contractorFields
  );

  const formikInitialValues = useMemo(
    () =>
      initialData
        ? initialData
        : generateFormikInitialValues(contractorFieldsWithDisable),
    [initialData]
  );
  const formikValidationSchema = useMemo(
    () => generateFormikValidationSchema(contractorFieldsWithDisable),
    [initialData]
  );
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formikInitialValues,
    validationSchema: formikValidationSchema,
  });

  const getDynamicFieldKey = (id) => `${id}-dynamic-field`;

  const submitContractorData = async () => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      const copyOffense = { ...formik.values };
      const correctData = contractorDataPutCorrector(
        violationData,
        copyOffense,
        user.id
      );

      const response = await MasterOfActsAPI.putContractorViolations(
        selectedAct.organization,
        selectedAct.violation_id,
        correctData
      );
      if (response.status === 201 || response.status === 200) {
        formik.resetForm(formikInitialValues);
        handleClose();
        dispatch(loadingContractorActs(whichUser()));
        clearViolationInfo()
      }
    } else {
      let touched = {};
      for (const field of Object.keys(errors)) {
        touched[field] = true;
      }
      await formik.setTouched(touched, false);
      await formik.setErrors(errors);
    }
  };


  

  return (
    <>
      {(user?.is_staff || user?.role === "project_editor" || user?.role === "employer" || user?.role === "employer_additional") &&
      <Select data={podrOrganizations}
                  formControlProps={{variant: 'outlined'}}
                  selectProps={
                              {
                                  className: classes.selectOption,
                                  classes: {
                                      outlined: classes.selectOutlined
                                  }
                              }
                          }
                  uniqueKey={'header-podr'}
                  value={podr}
                  onChange={handleContractors}

      />}
      <Typography className={classes.header} variant={"h4"}>
          {(user?.is_staff || user?.role === "project_editor" || user?.role === "employer" || user?.role === "employer_additional")  ? podr : user.organization}
      </Typography>
      <Paper style={{ height: "95%", width: "100%" }}>
        <DataGrid
          rows={currentRows?.map((el, index) => ({
            ...el,
            sequenceNumber: index + 1,
          }))}
          columns={columns}
          components={{ Toolbar: CustomToolbar }}
          density={"compact"}
          localeText={
            ruRU?.props?.MuiDataGrid?.localeText ||
            ruRU?.components?.MuiDataGrid?.defaultProps?.localeText
          }
          loading={loading}
          getRowId={(row) => row.sequenceNumber}
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => requestSearch(event.target.value),
            },
          }}
          onRowDoubleClick={onTableRowClick}
          disableSelectionOnClick
          disableColumnMenu
          pageSize={pageSize}
          onPageSizeChange={(newPage) => setPageSize(newPage)}
          pagination
          cell--textRight
        />
        {open ? (
          <Dialog
            open={open}
            handleClose={() => {clearViolationInfo(); handleClose()}}
            title="Подтверждение исправленных нарушений"
            fullWidth
            maxWidth={"md"}
          >
            {!loadingViolations && initialData && !loadingFiles ? (
              <>
                <Grid container spacing={1} direction={"column"}>
                  {infoViolation !== null &&
                    <Typography variant="h6">
                        Подрядчик: {infoAct.content.podrCompanystep1}<br/> 
                        Номер бригады: {infoAct.content.numBrigade}<br/>  
                        Дата выявления: {infoAct.content.dateAkttime}<br/> 
                        Статус нарушения: {infoViolation.removal_status === false ? 'Не устранено': 'Устранено'}<br/> 
                    </Typography>

                  }
                  {contractorFields?.map((field) => (
                    <Grid item key={getDynamicFieldKey(field.id)}>
                      <DynamicFieldComponent
                        {...field}
                        {...formik.getFieldProps(field.variable)}
                        touched={formik.touched[field.variable]}
                        error={formik.errors[field.variable]}
                        setFieldValue={formik.setFieldValue}
                        selectedactid={selectedAct.violation_id}
                      />
                    </Grid>
                  ))}
                  <QrCodeViolation qrHash={infoViolation?.qrcode_web} />
                </Grid>
                <Grid
                  item
                  style={{
                    marginTop: 15,
                    display: "flex",
                    justifyContent: "flex-end",
                  }}
                >
                  <ContractorSaveButton onClick={submitContractorData} />
                </Grid>
              </>
            ) : (
              <Loader />
            )}
          </Dialog>
        ) : null}
      </Paper>
    </>
  );
};
